import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const IconsList = ({ iconsListContent: content }) => {
  return (
    <div className="mt-10 mb-10 flex flex-col gap-12">
      {(content || []).map((item) => (
        <VisibleLoading key={item.id}>
          {({ ref, className }) => (
            <IconsListItem innerRef={ref} className={className} icon={item.icon} text={item.text} />
          )}
        </VisibleLoading>
      ))}
    </div>
  );
};
export default IconsList;

const IconsListItem = ({ innerRef, className, icon, text }) => {
  return (
    <div ref={innerRef} className={`flex min-w-[300px] items-center gap-5 ${className || ''}`.trim()}>
      <div className="flex h-[48px] w-[48px] items-center justify-center rounded-full bg-linear-[45deg,transparent_10%,var(--color-white-50)]">
        <div className="flex h-[45px] w-[45px] items-center justify-center rounded-full bg-[#0c0c0c]">
          <Icon type={icon} width={26} height={26} />
        </div>
      </div>
      <div className="txt-xl text-left font-medium text-white">{text}</div>
    </div>
  );
};
